<template>
  <v-card class="pt-3" flat>
    <v-card-title class="headline">Редактирование свойств</v-card-title>
    <v-card-text>
      <v-form v-model="isValid">
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Название"
              v-model="dealer.name"
              :rules="[notEmptyRule, length100]"
              counter="100"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              label="Страна"
              v-model="dealer.country"
              :rules="[notEmptyRule, length100]"
              counter="100"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Город"
              v-model="dealer.city"
              :rules="[notEmptyRule, length100]"
              counter="100"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              label="Телефон"
              v-model="dealer.phone"
              :rules="[notEmptyRule, length100]"
              counter="100"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Email"
              v-model="dealer.email"
              :rules="[notEmptyRule, emailRule, length100]"
              counter="100"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-select
              v-model="dealer.moneyFor"
              label="Деньги кому?"
              :items="ourLeEntities"
              :rules="[notEmptyRule]"
            >  
            </v-select>
          </v-col>

          <v-col cols="12">
            <v-textarea
              label="Доп. инфо"
              :rows="3"
              v-model="dealer.description"
              :rules="[notEmptyRule]"
            ></v-textarea>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              label="Изменил"
              v-model="dealer.creatorName"
              disabled
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Дата последнего изменения"
              v-model="formatUpdateTime"
              disabled
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="primary darken-1"
        text
        @click="updateDealerData"
        :disabled="!isValid"
        >Сохранить
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import API from "@/axios/api";
import FormatDateTime from "@/utils/time.js";

export default {
  props: ["dealerId"],
  data() {
    return {
      dealer: {},
      ourLeEntities: [],
      choices: {},
      isValid: true,
      notEmptyRule: (v) => !!v || "Поле не может быть пустым",
      emailRule: (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(v) ||
        "Неверный формат email",
      length100: (v) => (v && v.length <= 100) || "Максимум 100 символов",
    };
  },
  methods: {
    back() {
      history.back();
    },
    async getDealerData() {
      const response = await API.get(`dealers/${this.dealerId}`)
      console.log(response.data);
      this.dealer = response.data.dealer;
    },
    async getOurLeEntitiesData() {
      const response = await API.get('our_legal_entities/list_for_choices')
      console.log(response.data)
      this.ourLeEntities = response.data.choices
    },
    updateDealerData() {
      API.post(`dealers/${this.dealerId}`, this.dealer)
        .then((response) => {
          console.log(response.data);
          this.$store.dispatch("showSnackbar", {
            color: "success",
            text: "Свойства Дилера обновлены",
          });
          this.getDealerData();
          this.$emit("update", this.dealer.name);
          this.$store.dispatch("updateDealers");
        })
        .catch((error) => {
          this.$store.dispatch("showSnackbar", {
            color: "error",
            text: "Свойства Дилера не обновлены",
          });
          console.log(error);
        });
    },
  },
  async created() {
    await Promise.all([
      this.getDealerData(),
      this.getOurLeEntitiesData()
    ])
    if (this.dealer.moneyFor && this.ourLeEntities.find(el => el.value === this.dealer.moneyFor) == undefined) {
      this.dealer.moneyFor = null
    }
    this.$emit("ready", this.dealer.name)
  },
  computed: {
    formatUpdateTime() {
      if (this.dealer.updateTime == null) return "";
      return FormatDateTime(this.dealer.updateTime);
    },
  },
};
</script>